import $ from "jquery";

$('.scroll-to').on('click', function(e){
  console.log('asdasd', $(this).is('a'));
  var $this;
  var href;
  if ($(this).is('a')) {
    $this = $(this);
    href = $this.attr('href');
  } else {
    // e.preventDefault();
    $this = $(this).find('a');
    href = $this.attr('href');
    href = href.split('#');
    href = '#' + href[1];
    console.log($this);
    console.log(href);
  }

  $('html, body').animate({
    'scrollTop': $(href).offset().top - 140
  }, 1000);
});


// $(document).on('click', 'a[href^="#"]', function (event) {
//   event.preventDefault();

//   $('html, body').animate({
//       scrollTop: $($.attr(this, 'href')).offset().top
//   }, 500);
// });


window.addEventListener("load", function(){
  if(window.location.hash) {
    var hash = window.location.hash;
    setTimeout(function(){
      $('html, body').animate({
        'scrollTop': $(hash).offset().top - 140
      }, 1000);
    }, 1000);
  }
});